module.exports = __webpack_public_path__ + "img/idcard-back-example.e3201d61.png";